var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewProductionIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-26",
    transform: "translate(-30.000000, -237.000000)",
    fill: "#F72B94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(30.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(0.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4352727,7.24945455 L9.75309091,7.24945455 C9.18363636,8.91236364 7.70581818,9.93345455 5.83527273,9.93345455 C3.97054545,9.93345455 2.49272727,8.91236364 1.91854545,7.24945455 L1.23127273,7.24945455 C1.81745455,9.29418182 3.61745455,10.6392727 5.83490909,10.6392727 C8.032,10.6392727 9.83090909,9.29418182 10.4349091,7.24945455 L10.4352727,7.24945455 Z M5.83563636,9.02545455 C7.74618182,9.02545455 8.97236364,7.58436364 8.97236364,5.76472727 C8.97236364,3.94545455 7.74618182,2.504 5.83563636,2.504 C3.90654545,2.504 2.69854545,3.94509091 2.69854545,5.76472727 C2.69854545,7.58436364 3.90654545,9.02545455 5.83563636,9.02545455 L5.83563636,9.02545455 Z M5.83563636,0 C9.24290909,0 11.6585455,2.54036364 11.6585455,5.76472727 C11.6585455,8.98909091 9.24290909,11.5294545 5.83563636,11.5294545 C2.41018182,11.5294545 0.0127272727,8.98909091 0.0127272727,5.76472727 C0.0127272727,2.54036364 2.41018182,0 5.83563636,0 Z",
    id: "Shape"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProductionIcon);
export default __webpack_public_path__ + "static/media/newProductionIcon.a54dddad.svg";
export { ForwardRef as ReactComponent };